// BABA AI - AI SERVICE
// Together AI integration with Meta-Llama-3.1-405B-Instruct-Turbo

const TOGETHER_API_KEY = 'YOUR_TOGETHER_API_KEY_HERE'; // Replace with actual key
const TOGETHER_API_URL = 'https://api.together.xyz/v1/chat/completions';
const MODEL = 'meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo';

export const sendMessage = async (messages) => {
  try {
    const response = await fetch(TOGETHER_API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${TOGETHER_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: MODEL,
        messages: messages,
        max_tokens: 2000,
        temperature: 0.7,
        top_p: 0.7,
        top_k: 50,
        repetition_penalty: 1,
        stop: ['<|eot_id|>', '<|eom_id|>']
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Together AI API error: ${errorData.error?.message || response.statusText}`);
    }

    const data = await response.json();
    
    if (!data.choices || !data.choices[0] || !data.choices[0].message) {
      throw new Error('Invalid response from Together AI API');
    }

    return data.choices[0].message.content;
  } catch (error) {
    console.error('AI Service Error:', error);
    throw error;
  }
};

export default { sendMessage };
